export const blogs = [
    {
        path: "/blog/IndianOSInitiative",
        image_link: require("../assets/images/blogs/An indian OS thumbnail.png"),
        title: "The Indian OS Initiative: Empowering Digital Independence",
        description: "Discover how India's homegrown OS aims to redefine digital freedom and innovation.",
      },
      {
        path: "/blog/studyhabitpage",
        image_link: require("../assets/images/blogs/Effective Study habits Thumbnail.png"),
        title: "Effective Study Habits for Academic Success",
        description: "Boost learning with techniques like active recall, note-taking, and concept mapping.",
      },
      {
        path: "/blog/DigitalLiteracyGenZPage",
        image_link: require("../assets/images/blogs/GenZ -Develop Digital Minds Thumbnail.png"),
        title: "Digital Literacy and Gen Z: Navigating the Online World",
        description: "Explore the digital skills Gen Z needs to thrive in today’s tech-driven world.",
      },
      {
        path: "/blog/MindfulnessWellBeingPage",
        image_link: require("../assets/images/blogs/Mindfulness and well being Thumbnail.png"),
        title: "Mindfulness and Well-Being: Living in the Present",
        description: "Learn how mindfulness can reduce stress and enhance personal well-being.",
      },
      {
        path: "/blog/OnlineLearningPage",
        image_link: require("../assets/images/blogs/Online Learning from an early age Thumbnail.png"),
        title: "Online Learning from an Early Age: A Pathway to Brighter Minds",
        description: "Understand how early online education shapes smarter, future-ready learners.",
      },
      {
        path: "/blog/OnlineVsOfflineLearning",
        image_link: require("../assets/images/blogs/Online vs offline learning thumbnail.png"),
        title: "Online vs Offline Learning: Bridging the Gap",
        description: "Compare both learning modes and discover the strengths of each approach.",
      },
      {
        path: "/blog/TimeManagementStudyHabit",
        image_link: require("../assets/images/blogs/Time Management Thumbnail.png"),
        title: "10 Tips for Better Time Management and Study Habits",
        description: "Master your schedule and study smarter with these essential productivity tips.",
      },
]